/** 默认分页数量 */
export const DEFAULT_PAGE_SIZE = 18;

/** 搜索业务场景枚举 */
/** */
export enum EnumSearchBiz {
  /** 发起搜索 */
  RealSearch = 'real_search',
  /** 滚动页面分页请求 */
  ScrollPageSearch = 'search_pagination',
  /** 通过筛选器发起搜索 */
  FilterSearch = 'search_filter',
  /** 通过改变排序发起搜索 */
  SortSearch = 'search_sort',
  /** 在全局搜索下拉框中获取搜索建议 */
  SuggestionsInSearchBar = 'search_bar',
  /** 在搜索结果页的搜索下拉框中获取搜索建议 */
  SuggestionsInResultPage = 'search_bar_result',
  /** 未定义场景 */
  Others = 'others',
}
